<template>
    <template v-if="type === 'ESTIMATED_PROBABILITY'">
        <div
            class="match-detail-sidebar"
            v-if="isMobile && currentPage === 'FOOTBALL_LATEST'"
        >
            <div
                class="match-detail-estimated-probability"
                v-if="Object.keys(matchDetailWinRate).length !== 0"
            >
                <div class="match-detail-sidebar-title">
                    {{ $t("ESTIMATED_PROBABILITY") }}
                </div>

                <div class="estimated-probability-list">
                    <div class="estimated-probability-item">
                        <Icon
                            :logoUrl="matchDetailWinRate.homeLogo"
                            class="estimated-probability-img"
                        ></Icon>
                        <div class="estimated-probability-progress">
                            <div
                                class="rate-progress win-rate"
                                :style="{
                                    width: `${matchDetailWinRate.winRate}%`,
                                    borderRadius:
                                        matchDetailWinRate.winRate > 98
                                            ? '8px'
                                            : '8px 0 0 8px',
                                }"
                            ></div>
                            <div class="rate-text">
                                {{ matchDetailWinRate.winRate }}%
                            </div>
                        </div>
                    </div>
                    <div class="estimated-probability-item">
                        <IconMode>
                            <template #default="{ index }">
                                <img
                                    src="@static/images/icons/aspn_icon/estimated_probability/2.png"
                                    v-if="
                                        ['lightWeb', 'lightWebapp'].includes(
                                            index
                                        )
                                    "
                                    class="estimated-probability-img"
                                />
                                <img
                                    src="@static/images/icons/aspn_icon/estimated_probability/2_dark.png"
                                    v-else-if="
                                        ['darkWeb', 'darkWebapp'].includes(
                                            index
                                        )
                                    "
                                    class="estimated-probability-img"
                                />
                            </template>
                        </IconMode>
                        <div class="estimated-probability-progress">
                            <div
                                class="rate-progress draw-rate"
                                :style="{
                                    width: `${matchDetailWinRate.drawRate}%`,
                                    borderRadius:
                                        matchDetailWinRate.drawRate > 98
                                            ? '8px'
                                            : '8px 0 0 8px',
                                }"
                            ></div>
                            <div class="rate-text">
                                {{ matchDetailWinRate.drawRate }}%
                            </div>
                        </div>
                    </div>
                    <div class="estimated-probability-item">
                        <Icon
                            :logoUrl="matchDetailWinRate.awayLogo"
                            class="estimated-probability-img"
                        ></Icon>

                        <div class="estimated-probability-progress">
                            <div
                                class="rate-progress lose-rate"
                                :style="{
                                    width: `${matchDetailWinRate.loseRate}%`,
                                    borderRadius:
                                        matchDetailWinRate.loseRate > 98
                                            ? '8px'
                                            : '8px 0 0 8px',
                                }"
                            ></div>
                            <div class="rate-text">
                                {{ matchDetailWinRate.loseRate }}%
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <NoData v-else /> -->
                <!-- <div class="no-data" v-else>
                  {{ $t("NO_DATA") }}
                </div> -->
            </div>
        </div>
    </template>
    <template v-else-if="type === 'MATCH_INFO'">
        <div
            class="match-info"
            v-if="isMobile && currentPage === 'FOOTBALL_LATEST'"
        >
            <div class="match-detail-sidebar-title">
                {{ $t("MATCH_INFO") }}
            </div>

            <div class="match-info-list">
                <div class="match-info-item" v-if="matchDetailInfo.matchDate">
                    <div class="mr-1rem">
                        <SvgIcon icon="match-info.date"></SvgIcon>
                    </div>
                    <!-- <IconMode>
                    <template #default="{ index }">
                      
                      <img src="@static/images/icons/aspn_icon/match_info/match_icon_1.png" v-if="['lightWeb','lightWebapp'].includes(index)" />
                      <img src="@static/images/icons/aspn_icon/match_info/match_icon_1_dark.png" v-else-if="['darkWeb','darkWebapp'].includes(index)" />
                    </template>
                  </IconMode> -->
                    <span>{{ matchDetailInfo.matchDate }}</span>
                </div>
                <div class="match-info-item" v-if="matchDetailInfo.referee">
                    <div class="mr-1rem">
                        <SvgIcon icon="match-info.referee"></SvgIcon>
                    </div>
                    <span>{{ matchDetailInfo.referee }}</span>
                </div>
                <div class="match-info-item" v-if="matchDetailInfo.stadium">
                    <div class="mr-1rem">
                        <SvgIcon icon="match-info.stadium"></SvgIcon>
                    </div>
                    <span>{{ matchDetailInfo.stadium }}</span>
                </div>
            </div>
        </div>
    </template>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    props: ["matchDetailInfo", "matchDetailWinRate", "type", "currentPage"],
    computed: {
        ...mapGetters(["isMobile"]),
    },
};
</script>

<style scoped>
.match-detail-sidebar {
    width: 300px;
    flex-shrink: 0;
}
.match-detail-sidebar-title {
    font-size: var(--typography-heading-size-extra-small);
    font-family: var(--weight-600);
    margin-bottom: 16px;
    color: var(--color-text-default-default);
}
.match-detail-content-box {
    gap: 24px;
}
.match-info {
    border-radius: var(--size-radius-400);
    background: var(--color-background-default-secondary);
    padding: 16px;
}
.match-detail-estimated-probability {
    margin-top: 24px;
    padding: 16px;
    border-radius: var(--size-radius-400);
    background: var(--color-background-default-secondary);
}
.match-info-item {
    display: flex;
    margin-bottom: 18px;
    align-items: center;
    color: var(--color-text-default-default);
}
.match-info-item:last-child {
    margin-bottom: 0;
}
.match-info-item img {
    width: 20px;
    margin-right: 20px;
}
.estimated-probability-list {
}
.estimated-probability-item {
    display: flex;
    width: 100%;
    position: relative;
    align-items: center;
    margin-bottom: 32px;
}
.estimated-probability-item:last-child {
    margin-bottom: 0px;
}
.estimated-probability-img {
    width: 27px;
}
.estimated-probability-progress {
    width: calc(100% - 32px);
    height: 16px;
    background-color: var(--color-bar-background);
    border-radius: var(--size-radius-200);
    position: absolute;
    top: calc(50% - 8px);
    border-radius: 8px;
    left: 32px;
}

.rate-progress {
    height: 16px;
    border-radius: 8px 0 0 8px;
    position: absolute;
}
.win-rate {
    background-color: var(--primary-400);
}
.draw-rate {
    background-color: var(--color-background-neutral-default);
}
.lose-rate {
    background-color: var(--secondary-400);
}
.rate-text {
    display: flex;
    justify-content: right;
    font-size: var(--typography-caption-size-small);
    font-family: var(--weight-700);
    line-height: 16px;
    margin-right: 8px;
    color: var(--color-text-default-default);
    position: relative;
    letter-spacing: 0.2px;
}
@media(max-width: 768px) {
    /* for test */
    .match-detail-sidebar {
        width: 100%;
    }
    .match-detail-estimated-probability {
    }
    .match-detail-sidebar-title {
        text-align: center;
        font-size: 24px;
        letter-spacing: -0.64px;
        font-family: var(--weight-600);
    }
    .estimated-probability-item {
        margin-bottom: 16px;
    }

    .estimated-probability-progress {
        width: calc(100% - 40px);
        left: 40px;
    }
    .tab-wrapper {
        align-items: baseline;
        width: 100%;
        background-color: var(--white-1000);
    }
    .sub-nav__child .nav-pill:last-child {
        margin-right: 0 !important;
    }

    .sub-nav__child-indicator {
        margin-top: 14px;
    }
    .sub-nav__child {
        margin: 0.5rem 0.5rem 0 0.5rem;
    }
    .match-info {
        /* margin-top: 16px; */
    }
    .match-detail-estimated-probability {
        margin-top: 0px;
        border-radius: 8px;
        margin-bottom: 16px;
    }
    .match-detail__content-container {
        margin: 0 8px;
        width: calc(100% - 16px);
    }
}
</style>
